<template>
  <div>
    <!-- BOOLEAN -->
    <template v-if="inputType == 'boolean'">
      <v-row align-content="center" align="center">
        <v-col style="max-width: 65px;">{{ $t("FALSE") }}</v-col>
        <v-col style="max-width: 60px;"
          ><v-switch v-model="internalValue"
        /></v-col>
        <v-col style="max-width: 65px;">{{ $t("TRUE") }}</v-col>
      </v-row>
    </template>

    <!-- ENUM -->
    <template v-else-if="inputType == 'enum'">
      <v-select
        :items="inputOptions"
        v-model="internalValue"
        :label="inputField"
      />
    </template>

    <!-- NUMBER -->
    <template v-else-if="inputType == 'number'">
      <v-text-field v-model="internalValue" type="number" :label="inputField" />
    </template>

    <!-- STRING -->
    <template v-else-if="inputType == 'string'">
      <v-text-field v-model="internalValue" :label="inputField" />
    </template>

    <!-- OTHER ?? -->
    <template v-else> </template>
  </div>
</template>

<script>
export default {
  props: {
    inputField: String,
    attributes: Array,
    value: [String, Number, Boolean],
  },

  watch: {
    inputField(val) {
      this.internalValue = null;

      let attribute = this.attributes.find((a) => a.name == val);
      this.inputType = attribute.type;

      if (attribute.type == "enum") {
        this.inputOptions = attribute.options;
      } else if (attribute.type == "boolean") {
        this.internalValue =
          this.value === "TRUE" || this.value == null ? false : this.value;
      }

      this.$forceUpdate();
    },

    inputType(val) {
      if (val == "boolean") {
        if (this.internalValue == null) {
          this.internalValue = false;
        }
      }
    },

    internalValue(val) {
      this.$emit("input", val);
    },
  },

  data() {
    return {
      inputType: null,
      inputOptions: null,
      internalValue: null,
    };
  },

  created() {
    this.internalValue = this.value;

    let attribute = this.attributes.find((a) => a.name == this.inputField);
    this.inputType = attribute.type;
    if (attribute.type == "enum") {
      this.inputOptions = attribute.options;
    } else if (attribute.type == "boolean") {
      this.internalValue = this.value === "TRUE" || this.value;
    }
    this.$forceUpdate();
  },

  methods: {
    increment() {
      if (this.internalValue == null) {
        this.internalValue = 0;
      }
      this.internalValue = parseInt(this.internalValue, 10) + 1;
    },

    decrement() {
      if (this.internalValue == null) {
        this.internalValue = 0;
      }
      this.internalValue = parseInt(this.internalValue, 10) - 1;
    },
  },
};
</script>
